import { Box, Card, CircularProgress, Grid, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import BrochureModal from "components/Modals/commands/BrochureModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import EditIcon from '@mui/icons-material/Edit';
import { axiosClient } from "Api/axoisClient";
import Swal from "sweetalert2";




export default function Brochure() {
  const {t} = useTranslation();


  const columns = [
    { Header: "type", accessor: "Type", align: "left" },
    { Header: "max-CompanyBrochures", accessor: "max_company_brochures", align: "center" },
    { Header: "max-AnnouncementBrochures", accessor: "max_announcement_brochures", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];
  const [openCreate, setOpenCreate] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [planInfo, setplanInfo] = useState({});
  const [Reload, setReload] = useState(false);
  const [rows, setRows] = useState([]);
  const [process, setProcess] = useState(false);
  

  useEffect(() => {
    (async () => {
      setisLoading(true)
      try {
        const res = await axiosClient.get(
          `/plans`
        );

        if (res.status === 200 && res.data?.data?.length > 0) {
          setRows(
            res?.data?.data?.map((item) => {
              return {
                Type: (
                  <MDTypography
                    component="a"
                    href="#"
                    variant="caption"
                    fontSize={15}
                    color="text"
                    fontWeight="medium"
                  >
                    {item?.type}({item?.id})
                  </MDTypography>
                ),
                max_company_brochures: (
                  <MDTypography
                    component="a"
                    href="#"
                    variant="caption"
                    fontSize={15}
                    color="text"
                    fontWeight="medium"
                  >
                    {item?.max_company_brochures ?? t('plans.unlimited')}
                  </MDTypography>
                ),
                max_announcement_brochures: (
                    <MDTypography
                      component="a"
                      href="#"
                      variant="caption"
                      fontSize={15}
                      color="text"
                      fontWeight="medium"
                    >
                      {item?.max_announcement_brochures ?? t('plans.unlimited')}
                    </MDTypography>
                  ),
                action: (
                  <Box className="flex items-center gap-2">

                    <Tooltip title={t('plans.tooltips.information')}>
                      <EditIcon
                        className="text-blue-500"
                        sx={{ fontSize: "18px !important" }}
                        onClick={(e) => ShowCompany(e, item?.id)}
                      />
                    </Tooltip>

                    {/* <Tooltip title="information">
                      <DeleteIcon
                        className="text-red-500"
                        sx={{ fontSize: "18px !important" }}
                        onClick={(e) => Delete(e, item?.id)}
                      />
                    </Tooltip> */}

                  </Box>
                ),
              };
            })
          );
        } else {
          setRows([]);
        }
      } catch (rej) {
        setRows([]);
      }
      setisLoading(false)
    })();
  }, [Reload]);
   const ShowCompany = async (e, id) => {
  
      if(!process){
        setProcess(true)
        try {
          const res = await axiosClient.get(`/plans/${id}`);
    
          if (res.status === 200) {
            setplanInfo(res.data);
            setOpenUpdate(true);
          }
        } catch (err) {Swal.fire({
          icon: "error",
          title: t("modals.command.messages.error.title"),
          text: t("modals.command.messages.error.text"),
    });
        }
        setProcess(false)
      }
  
    };
    return (

        <DashboardLayout>
                <DashboardNavbar />
        
        {openCreate && (
        <BrochureModal
          plan={planInfo} 
          setReload={setReload}
          action="create" 
          open={openCreate}
          setOpen={setOpenCreate} 
        />
      )}

      {openUpdate && (
        <BrochureModal
          plan={planInfo} 
          setReload={setReload}
          action="update" 
          open={openUpdate} 
          setOpen={setOpenUpdate} 
        />
      )} 

      <Grid item xs={12}>
        <Card className="mt-14">
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              Brochures
            </MDTypography>
          </MDBox>
          <MDBox pt={1}>

            {
              !isLoading && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={{
                    defaultValue: 20,
                    entries: [],
                  }}
                  showTotalEntries={false}
                  noEndBorder
                />
              )
            }
            {
              isLoading ? (
                <MDBox
                mb={3}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress color='info' /> 
              </MDBox>
                ): rows.length === 0 && <p className="text-center mb-10 w-full">No plans</p>
            }


          </MDBox>
        </Card>
      </Grid>
        </DashboardLayout>
    )
}